var _style, _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#881421;}\n\t.st1{fill:#AF2031;}\n\t.st2{fill:#C94F60;}\n\t.st3{fill:#E08095;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{opacity:0.2;enable-background:new    ;}\n\t.st6{fill:url(#SVGID_1_);}\n\t.st7{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,36.4v7.4c0,2,5.4,3.7,12.1,3.7s12.1-1.6,12.1-3.7v-7.4H23.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.1,28.4v8.1c0,2,5.4,3.7,12.1,3.7s12.1-1.6,12.1-3.7v-8.1H23.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,20.3v8.1c0,2,5.4,3.7,12.1,3.7s12.1-1.6,12.1-3.7v-8.1H23.1z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 35.2,
    cy: 20.3,
    rx: 12.1,
    ry: 3.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M32,23.2h-8.9v18.4H32c0.7,0,1.3-0.6,1.3-1.3V24.6C33.4,23.8,32.8,23.2,32,23.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.3,24h-8.2v18.4h8.2c0.7,0,1.3-0.6,1.3-1.3V25.3C32.6,24.6,32,24,31.3,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M31.3,24h-8.2v16.9h8.2c0.7,0,1.3-0.6,1.3-1.3V25.3C32.6,24.6,32,24,31.3,24z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.5,24h-7.5v16.9h7.5c0.7,0,1.3-0.6,1.3-1.3V25.3C31.9,24.6,31.3,24,30.5,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 18.5288,
    y1: -1326.2229,
    x2: 29.0819,
    y2: -1307.9452,
    gradientTransform: "matrix(1 0 0 1 0 1349.1207)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B72C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#B12334"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9D1623"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M17.1,24h13.5c0.7,0,1.3,0.6,1.3,1.3v13.5c0,0.7-0.6,1.3-1.3,1.3H17.1c-0.7,0-1.3-0.6-1.3-1.3V25.3 C15.7,24.6,16.3,24,17.1,24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M22.8,27.7h2l3.2,8.8h-1.9l-0.7-2.1h-3.3l-0.7,2.1h-1.9L22.8,27.7z M25,33l-1-3.2c-0.1-0.2-0.1-0.5-0.2-0.7h0 c0,0.3-0.1,0.5-0.2,0.7l-1,3.2L25,33z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.6ea7136c7a1dba1c0b6cb684603f7929.svg";
export { ForwardRef as ReactComponent };